import { useNavigate } from "react-router-dom";
import { AlertTriangle } from "lucide-react";

export default function CustomErrorPage() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-6">
      <div className="max-w-md text-center bg-white shadow-lg rounded-2xl p-8 border border-gray-200">
        <AlertTriangle className="w-12 h-12 text-red-500 mx-auto" />
        <h2 className="text-2xl font-semibold text-gray-800 mt-4">Service Unavailable</h2>
        <p className="text-gray-600 mt-2">
          We&apos;re experiencing a high volume of requests right now. Please try again in a little while—we appreciate your patience!
        </p>
        <button
          className="mt-6 bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg"
          onClick={() => navigate("/")}
        >
          Back to Home
        </button>
      </div>
    </div>
  );
}
